window.MF = window.MF || {};
window.MF.YammerHelper = function () {
  var allowedExternalNetworkPermalinks = [];
  var allowedExternalNetworkTokens = [];

  var uri = MF.UriHelper;
  var win = MF.WindowHelper;
  var config = mfConfig.YammerConfig;

  var accessToken = '';
  var lastAuth = null;

  // dependencies: yam, MF, UriHelper, WindowHelper
  function buildStatusUri(msg, permalink) {
    permalink = permalink ? permalink + "/" : "/";
    return config.url + permalink + "messages/new?status=" + uri.encode(msg) + "#/Messages/bookmarklet?type=following";
  }

  function buildCourseUri(courseId, courseTitle) {
    return uri.getDomain() + "/Yammer/yammerusers.aspx?courseID=" + courseId + '&courseTitle=' + uri.encode(courseTitle);
  }

  function buildSeriesUri(seriesId, seriesTitle) {
    return uri.getDomain() + "/Yammer/yammerusers.aspx?seriesID=" + seriesId + '&seriesTitle=' + uri.encode(seriesTitle);
  }

  function buildAccountUri() {
    return uri.getDomain() + "/Yammer/yammerusers.aspx";
  }

  function buildGetAuthTokensUri() {
    return uri.getDomain() + "/Yammer/GetAuthTokens.aspx";
  }

  function authUri(redirectUri) {
    return uri.build(config.oAuthUri,
      [
        'client_id=' + config.appId,
        'response_type=token',
        'redirect_uri=' + uri.encodeComponent(redirectUri)
      ]);
  }

  function openStatusPopup(msg) {
    var preferedNetworkPermalink = null;
    var preferedExternalNetworkId = $.cookie("yam-pref-ext-network-id");

    if (preferedExternalNetworkId && allowedExternalNetworkTokens) {
      var preferedNetworkTokens = $.grep(allowedExternalNetworkTokens, function (item) {
        return item.network_id == preferedExternalNetworkId;
      });

      if (preferedNetworkTokens.length > 0) {
        preferedNetworkPermalink = preferedNetworkTokens[0].network_permalink;
      }
    }

    return win.popup(buildStatusUri(msg, preferedNetworkPermalink));
  }

  function openCourseInvitePopup(courseId, courseTitle) {
    win.popup(authUri(buildCourseUri(courseId, courseTitle)));
  }

  function openSeriesInvitePopup(seriesId, seriesTitle) {
    win.popup(authUri(buildSeriesUri(seriesId, seriesTitle)));
  }

  function openAccountInvitePopup() {
    win.popup(authUri(buildAccountUri()));
  }

  function ready() {
    return typeof yam !== 'undefined';
  }

  // always refresh the token on the client
  function refreshToken(res) {
    lastAuth = res;
    accessToken = getToken(res);
    try {
      win.fetchSwf("trainerApp").refreshToken(accessToken);
    } catch (error) {
    }
  }


  function getToken(res) {
    accessToken = '';
    if (res.success) {
      // user just authenticated first time
      accessToken = res.access_token.access_token.token;
    } else if (res.authResponse) {
      // user was signed in already
      accessToken = res.access_token.token;
    }
    return accessToken;
  }

  function getAccessToken(callback) {
    if (!ready()) return;

    yam.platform.getLoginStatus(function (response) {
      refreshToken(response);
      var primaryToken = getToken(response);
      if (primaryToken && primaryToken != '') {
        loadAllTokens(primaryToken);
      }
      if (callback)
        callback(response);
    });
  }


  function loadAllTokens(primaryNetworkAccessToken) {
    if (!ready()) return;

    if (typeof config.allowedExternalNetworks == 'undefined' || config.allowedExternalNetworks.length == 0)
      return;

    allowedExternalNetworkPermalinks = config.allowedExternalNetworks.split(',');
    if (allowedExternalNetworkPermalinks.length == 0 || allowedExternalNetworkPermalinks[0].length == 0)
      return;

    // TODO: REPLACE WITH CALL TO OUR SERVER TO GET TOKENS

    $.ajax({
      url: buildGetAuthTokensUri(),
      type: 'POST',
      data: {
        token: primaryNetworkAccessToken
      },
      success: function (data) {
        var parsedData = eval(data);

        allowedExternalNetworkTokens = $.grep(parsedData, function (item) {
          return $.inArray(item.network_permalink, allowedExternalNetworkPermalinks) >= 0;
        });
      }
    });
  }

  $(document).ready(function () {
    if(!mfConfig.yammerEnabled) return;
    yam.config(config);
  });

  return {
    isReady: ready,
    init: function (callback) {
      getAccessToken(callback);
    },
    getLastAuth: function () {
      return lastAuth;
    },
    isLoggedIn: function () {
      getToken(lastAuth);
      if (accessToken)
        return true;
      else
        return false;
    },
    updateStatus: function (message, courseUrl) {
      var msg = escape(message + courseUrl);

      openStatusPopup(msg);
    },
    writeToStream: function (action, course, url) {
      if (!ready()) return;

      yam.platform.getLoginStatus(function (resp) {
        if (resp.authResponse) {
          var data = {
            activity: {
              actor: {
                name: resp.user.full_name,
                email: resp.user.contact.email_addresses[0].address
              },
              message: action,
              action: "update",
              object: {
                url: url,
                type: "page",
                title: course
              }
            }
          };

          yam.platform.request({
            url: "/api/v1/activity.json",
            method: "POST",
            data: data,
            success: function (msg) { },
            error: function (msg) { }
          });
        }
      });
    },
    authenticateForCourse: openCourseInvitePopup,
    authenticateForSeries: openSeriesInvitePopup,
    authenticateForAccount: openAccountInvitePopup,
    authenticateForStatus: function (message, courseUrl) {
      return openStatusPopup(escape(message + courseUrl));
    },
    auth: authUri,
    getAccessToken: getAccessToken
  };
}();

